var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconX(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Leading icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.13794 5.52859C6.87766 5.2683 6.45565 5.2683 6.19537 5.52859C5.93508 5.78887 5.93508 6.21088 6.19537 6.47116L7.72408 7.99987L6.19537 9.52859C5.93508 9.78887 5.93508 10.2109 6.19537 10.4712C6.45565 10.7314 6.87766 10.7314 7.13794 10.4712L8.66665 8.94245L10.1954 10.4712C10.4557 10.7314 10.8777 10.7314 11.1379 10.4712C11.3982 10.2109 11.3982 9.78887 11.1379 9.52859L9.60923 7.99987L11.1379 6.47116C11.3982 6.21088 11.3982 5.78887 11.1379 5.52859C10.8777 5.2683 10.4557 5.2683 10.1954 5.52859L8.66665 7.0573L7.13794 5.52859Z",
    fill: "#CF1220"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66666 0.666748C4.61667 0.666748 1.3335 3.94992 1.3335 7.99991C1.3335 12.0499 4.61667 15.3331 8.66666 15.3331C12.7167 15.3331 15.9998 12.0499 15.9998 7.99991C15.9998 3.94992 12.7167 0.666748 8.66666 0.666748ZM2.6665 7.99991C2.6665 4.68611 5.35286 1.99975 8.66666 1.99975C11.9805 1.99975 14.6668 4.68611 14.6668 7.99991C14.6668 11.3137 11.9805 14.0001 8.66666 14.0001C5.35286 14.0001 2.6665 11.3137 2.6665 7.99991Z",
    fill: "#CF1220"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconX);
export default __webpack_public_path__ + "static/media/icon-x.ee9275a1368d7767474db763bea74723.svg";
export { ForwardRef as ReactComponent };